import { takeLatest, all, call, put } from "redux-saga/effects";
import { getModelFiltersApi } from "../api/handler";
import { GET_MODEL_FILTERS } from "../actions/types";
import { setModelFilters, setLoading } from "../actions/index";
import store from "../store/index";

function* handleGetModelFilters(args) {
  yield put(setLoading(true));
  try {
    const response = yield call(getModelFiltersApi, args.params);
    if (response.status === 200) {
      yield put(setModelFilters(response.data));
    }
  } catch (err) {
    console.warn(err);
  }
  if (Object.keys(store.getState().vehicleList).length !== 1)
    yield put(setLoading(false));
}

export default function* modelFiltersSaga() {
  yield all([takeLatest(GET_MODEL_FILTERS, handleGetModelFilters)]);
}
